

(function() {
    // function getFlagEmoji(countryCode) {
    //   const codePoints = countryCode
    //     .toUpperCase()
    //     .split('')
    //     .map(char =>  127397 + char.charCodeAt());
    //   return String.fromCodePoint(...codePoints);
    // }

    function getCurrentCountryCode() {
      return document.documentElement.dataset.countryCode;
    }
  
    function addShippingTime() {
      var daysAfterToday = 1; // Set this to the number of days after today that the item will ship
      var today = new Date();
      var shipDate = new Date(today.setDate(today.getDate() + daysAfterToday));
      var options = { weekday: 'short', month: 'long', day: 'numeric' };
      var formattedDate = shipDate.toLocaleDateString('en-US', options);
      var flagImage = getCurrentCountrySRC();
      
      
      document.querySelectorAll('.country-flag-shipping').forEach(function (el) {
        var existingImg = el.querySelector('img');
        if (existingImg) el.removeChild(existingImg);
      
        var img = document.createElement('img');
        img.src = flagImage;
        img.alt = 'Country flag';
        el.prepend(img);
      });
      
      document.querySelectorAll('.shipping-date').forEach(function (el) { 
        el.textContent = formattedDate;
      });
    }
    
    var vectorsForSpakrling = {
        'default': function(options) {
            var size = options.size;
            return '<svg class="disable-fill-color" width="' + size + '" height="' + size + '" viewBox="0 0 68 68" fill="none"><path d="M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z" fill="currentColor" /></svg>';
        },
        'teddy': function() {
            return '<span>🐻</span>';
        },
        'pumpkin': function() {
            return '<span>🎃</span>';
        },
        'christmas-tree': function() {
            return '<span>🎄</span>';
        },
        'gift-box': function() {
            return '<span>🎁</span>';
        },
        "heart-bag-charm": function (options) {
          var size = options.size;

          return `<img src='https://cdn.shopify.com/s/files/1/0763/6169/5558/files/heart.png?v=1720810348' style="width: ${size}px; height: ${size}px" />`;
        },
        "susuwatari-bag-charm": function (options) {
          var size = options.size;

          return `<img src='https://cdn.shopify.com/s/files/1/0763/6169/5558/files/Photoroom_20240712_231631_8eb1f838-0773-450f-a7ae-5f20464f3491.png?v=1720852281' style="width: ${size}px; height: ${size}px" />`;
        },
        "schnauzer-bag-charm": function (options) {
          var size = options.size;

          return `<img src='https://cdn.shopify.com/s/files/1/0763/6169/5558/files/Photoroom_20240712_231519_48d42c56-81b3-4d2f-92e2-4585c3ced241.png?v=1720852348' style="width: ${size}px; height: ${size}px" />`;
        },
        "mr.bean-teddy-bag-charm": function (options) {
            return '<span>🐻</span>';
        },
    };

    function random(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function initSparkling() {
        var color = "#FFC700";
        var svgPath = '';

        function sparkling() {
            var sparklingElements = document.querySelectorAll('.sparkling');
            var productElement = document.querySelector('.product');
            var productName;
            if (productElement) {
              productName = productElement.getAttribute('data-name');
            }
            
            Array.prototype.forEach.call(sparklingElements, function(sparklingElement) {
                var stars = sparklingElement.getElementsByClassName('star');
                var isTouch = document.documentElement.classList.contains('touch');

                // if ((isTouch && !sparklingElement.classList.contains('sparkling-touch')) ||
                //     (!isTouch && sparklingElement.classList.contains('sparkling-touch'))) {
                //     return;
                // }

                if (stars.length > 5) {
                    sparklingElement.removeChild(stars[0]);
                }

                var vector = sparklingElement.getAttribute('data-vector') || productName || 'default';
                sparklingElement.insertAdjacentHTML('beforeend', addStar({ vector: vector }));
            });

            setTimeout(sparkling, random(300, 1700));
        }

        function addStar(options) {
            var vector = options.vector;
            var size = random(8, 30);
            var top = random(-50, 50);
            var left = random(0, 100);

            return '<span class="star" style="top:' + top + '%; left:' + left + '%;">' + (vectorsForSpakrling[vector] ? vectorsForSpakrling[vector]({ size: size }) : vectorsForSpakrling['default']({ size: size })) + '</span>';
        }

        sparkling();
    }

    function handleColorSwatchesVariantsExternalLink() {
      const options = document.querySelectorAll('.label-only-input[data-external-url]:not([data-handled-location-changer=true])');

      if (!options) {
        return;
      }
      
      for (let i = 0; i < options.length; i++) {
        if (options[i].dataset.externalUrl) {
          options[i].setAttribute('data-handled-location-changer', 'true');
          
          options[i].addEventListener("click", function() {
            window.location.href = options[i].dataset.externalUrl;
          });
        }
      }
    }

    function getCurrentCountrySRC() {
      var currentCountryCode = getCurrentCountryCode();
      
      if (!currentCountryCode) {
        return;
      }
      
      return "https://flagsapi.com/" + currentCountryCode + "/flat/64.png";
    }

    var headerCountryInterval;
  
    function handleCountryHeader() {
      var annbar = document.querySelector('.essential_countdown_annoucement_bar_wrapper p:last-child');

      if (!annbar) {
        clearInterval(headerCountryInterval);
        
        return;
      }

      if (annbar.querySelector('.country-flag')) {
        clearInterval(headerCountryInterval);
        
        return;
      }
      
      var wrapper = document.createElement('span');
      wrapper.className = 'country-flag';
    
      var img = document.createElement('img');
      img.src = getCurrentCountrySRC();
    
      wrapper.appendChild(img);

      // var currentCountry = document.documentElement.dataset.country;
      var currentCountryCode = getCurrentCountryCode();
      var text = document.createTextNode(" " + currentCountryCode.toUpperCase() + " ");

      annbar.appendChild(text);
      annbar.appendChild(wrapper);
    }

    function init() {
      initSparkling();
      addShippingTime();
      handleColorSwatchesVariantsExternalLink();

      headerCountryInterval = setInterval(function () {
        handleCountryHeader();
      }, 1500);
    }

    window.handleColorSwatchesVariantsExternalLink = handleColorSwatchesVariantsExternalLink;
    

    if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
        init();
      
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }

})();
